
import Vue from 'vue';
import Component from 'vue-class-component';
import apiClient from '../../clients/api-client';
import {AuthService} from '@/app/services/auth-service';
import TButton from '@/lib/form/button/Button.vue';
import TInput from '@/lib/form/input/Input.vue';
import TubeLabel from '@/lib/form/label/Label.vue';
import WorkspaceUtils from '@/app/utils/workspace-utils';
import TCheckbox from '@/lib/form/checkbox/Checkbox.vue';
import GTMService from '@/app/services/google-tag-manager-service';

@Component({
  name: 'workspace-setup',
  props: ['mode', 'context'],
  components: {
    TButton,
    TInput,
    TubeLabel,
    TCheckbox,
  },
})
export default class WorkspaceSetupComponent extends Vue {
  private isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  private workspaceName: string | null = null;
  private domainName: string | null = null;
  private workspaceError = '';
  private domainNameError = '';
  private loader = false;
  private joinWorkspaceLoader = false;
  private context: any;
  private loaded = false;
  private joinWorkspace = true;
  private memberships: any[] = [];
  private createNewWorkspace = false;
  private validDomainName = true;
  private canShowAutoJoin = true;
  private domain = '';
  private attributions = {};

  mounted() {
    apiClient
        .eligibleMemberships(
            this.context.googleToken,
            this.context.authToken,
            this.context.email
        )
        .then((memberships) => {
          this.memberships = memberships;
          this.loaded = true;
          if (this.$isEmpty(this.context) || !this.context.email) {
            return;
          }
          const domain = this.context.email.replace(/.*@/, '');
          this.domainName =
              [
                'gmail',
                'yahoo',
                'outlook',
                'hotmail',
                'icloud',
                'zoho',
                'hey',
                'protonmail',
                'aol',
                'yandex',
                'mailfence',
                'trustifi',
              ].indexOf(domain.split('.')[0]) == -1
                  ? domain.split('.')[0]
                  : '';
          this.canShowAutoJoin = !!this.domainName;
          if (this.canShowAutoJoin) {
            this.domain = domain;
          }
          this.workspaceName =
              this.domainName!.charAt(0).toUpperCase() + this.domainName!.slice(1);
          this.checkDomainNameAllowed();
        });
  }

  get attachmentTypes() {
    return ['image/jpeg', 'image/png'];
  }

  createNewWorkspaceInstead() {
    this.createNewWorkspace = true;
  }

  keyup() {
    this.workspaceError = '';
  }

  checkDomainNameAllowed() {
    if (typeof this.domainName!.replaceAll === 'function') {
      const sanitized = this.domainName!.replaceAll(/[^a-z0-9]/g, '-')
          .replaceAll(/\A\-+/g, '')
          .replaceAll(/\-+/g, '-');
      if (sanitized != this.domainName) {
        this.domainName = sanitized;
      }
    }
    return apiClient.domainNameCheck(this.domainName).then((result) => {
      this.validDomainName = result.allowed;
      if (this.domainName && result.invalid) {
        this.domainNameError =
            this.$t('onboard.register.workspace.domain.validity') + '';
      } else {
        this.domainNameError = '';
      }
    });
  }

  updateDomainName() {
    if (!this.workspaceName) {
      return '';
    }
    this.domainName = this.workspaceName.toLowerCase().split(' ').join('-');
  }

  takeMeToWorkspace(workspaceName) {
    const membership = this.memberships.filter(
        (m) => m.name == workspaceName
    )[0];
    this.joinWorkspaceLoader = true;
    apiClient
        .joinWorkspace(
            this.context.googleToken,
            this.context.authToken,
            this.context.email,
            membership.name,
            membership.id
        )
        .then(({token}) => {
          AuthService.getInstance().setWorkspaceName(workspaceName);
          return AuthService.getInstance()
              .setJwt(token)
              .then(() => {
                window.location.href = `${WorkspaceUtils.getCommonUrl()}/library`;
              });
        })
        .catch((error) => {
          this.$error(error);
          this.joinWorkspaceLoader = false;
        });
  }

  createWorkspace() {
    if (!this.workspaceName) {
      this.workspaceError =
          this.$t('onboard.register.workspace.input.error') + '';
      return;
    }
    if (this.workspaceName.length < 4) {
      this.workspaceError =
          this.$t('onboard.register.workspace.input.min_length_error') + '';
      return;
    }
    if (!this.domainName) {
      this.domainNameError =
          this.$t('onboard.register.workspace.domain.error') + '';
      return;
    }
    if (!this.validDomainName) {
      this.domainNameError =
          this.$t('onboard.register.workspace.domain.already_exists') + '';
      return;
    }
    this.loader = true;
    apiClient
      .createWorkspace(
        this.context.googleToken,
        this.context.authToken,
        this.workspaceName,
        this.domainName,
        this.joinWorkspace,
        this.attributions
      )
      .then(({ name, jwt, userId }) => {
        AuthService.getInstance().setWorkspaceName(name);
        return AuthService.getInstance()
          .setJwt(jwt)
          .then(() => {
            // this.$emit('update', {
            //   flowType: 'invite_team',
            // });
            GTMService.pushEvent('signed_up', userId);
            window.location.href = `${WorkspaceUtils.getCommonUrl()}/library`;
          });
      })
      .catch((error) => {
        this.$error(error);
        this.loader = false;
      });
  }
}
